

// Function to retrieve a value from local storage by key
function getFromLocalStorage(key) {
    return localStorage.getItem(key);
}

// Function to set a value in local storage with a specified key
function setToLocalStorage(key, value) {
    localStorage.setItem(key, value);
}

// Function to increase font size based on the query parameter value
function increaseFontSize() {
    const urlParams = new URLSearchParams(window.location.search);
    const queryParam = urlParams.has('s') ? 's' : urlParams.has('m') ? 'm' : urlParams.has('l') ? 'l' : null;
    const currentFontSizeLocalStorage = getFromLocalStorage('fontsize');
    let newSizePercentage = 0;

              
        var el = document.getElementById('font-check');
        var style = window.getComputedStyle(el, null).getPropertyValue('font-size');
        var fontSize = style;
        var fontSizePercentage = parseFloat(style) / 14 * 100;
        
        let zoom = ((window.outerWidth - 10) / window.innerWidth) * 100;

    if (fontSizePercentage > 100 || zoom > 100) {
        console.log("Already zoomed in");
    } else {

    // Check if queryParam has a value, otherwise check if currentFontSizeLocalStorage has a value
    if (queryParam !== null) {
        switch(queryParam) {
            case 's':
                newSizePercentage = 0;
                break;
            case 'm':
                newSizePercentage = 13;
                break;
            case 'l':
                newSizePercentage = 25;
                break;
            default:
                // If queryParam is present but not 's', 'm', or 'l', do nothing
                return;
        }
    } else if (currentFontSizeLocalStorage !== null) {
        // Use the value from currentFontSizeLocalStorage if queryParam is not present
        switch(currentFontSizeLocalStorage) {
            case 's':
                newSizePercentage = 0;
                break;
            case 'm':
                newSizePercentage = 13;
                break;
            case 'l':
                newSizePercentage = 23;
                break;
            default:
                // If currentFontSizeLocalStorage is present but not 's', 'm', or 'l', do nothing
                return;
        }
    } else {
      console.log("neither")
        // If neither queryParam nor currentFontSizeLocalStorage is present, do nothing
        return;
    }

    // Calculate the new font size based on the percentage increase
    const newFontSize = newSizePercentage;

    // Ensure the new font size is within the range of 0 to 50
    const boundedFontSize = Math.min(Math.max(newFontSize, 0), 30);

    // Always set the value in local storage with the new font size
    if (queryParam !== null) {
        setToLocalStorage('fontsize', queryParam);
    }

    // Create a style element to hold the dynamic styles
    let dynamicStyles = document.getElementById('dynamic-styles');
    if (!dynamicStyles) {
        dynamicStyles = document.createElement('style');
        dynamicStyles.id = 'dynamic-styles';
        document.head.appendChild(dynamicStyles);
    }

    // Define the classes you want to adjust
    const classesToAdjust = [
      '.duplicatetitle',
      '.preview',
      '.cart-notification-product__lineitem',
      '.page-title.center1',
      '.rightside',
      '.product-info',
      '.product-option',
      '.totals__subtotal',
      '.totals__subtotal',
      '.title',
      '.requiredterms',
      '.featuresmainsub',
      '.cart-notification-product .cart-remove-js',
      '.cart-notification-product__option',
      '.product__info-container .product-price .price-item--regular',
      '.product__info-container .product-price .price--on-sale .price-item--sale',
      '.price--on-sale .price-item--regular',
      '.price--on-sale .price-item--sale, .price-item--sale',
      '.front-engraving',
      '.back-engraving',
      '.finish-title',
      '.features-text-hp',
      '.features-text',
      '.collection-product-count',
      '.color-variants.collection',
      '.flag.soldout',
      '.cart-item__name',
      '.flag.sale',
      '.footer-block__details-content .list-menu__item--link',
      '.footer-block__heading.desktop',
      '.collection-text',
      '#redirect2',
      '.customer .field label, .field__label',
      '.color-variants',
      '.cart-button div',
      '.containercart b',
      '.product__info-container .product__title',
      '.price--large',
      '.closecart h3',
      '.qv-compareatprice',
      '.product-popup-modal #qv-text-container #qv-variants .swatch-wrapper .option-label',
      '.goal',
      '.form__label-upsell',
      'li.tab',
      '.alignmobile p',
      '.tab-engrave',
      '.cart-notification-product__name',
      '.facets__summary',
      '.form__label1',
      '.faq-question',
      '#mobile_top_menu_wrapper .top-menu .sub-menu .mainmenu-dropdown .sub-category .top-menu .category a',
      '.card-information__text',
      '.product-popup-modal__button',
      '.section-header>h2',
      'body, p',
      '.ishislider2 .ishislideshow-carousel .slider-content .slider-btn',
      '.ishislider2 .ishislideshow-carousel .slider-content .sub-title',
      '.ishislider2 .ishislideshow-carousel .slider-content .desc', // Corrected selector
      '#top-menu>li>a .title',
      '.viewcolor',
      '.features-text-hp',
      '.collection-list-section .collection-item',
      '.service-title',
      '.facets__summary',
      '.product-popup-modal #qv-text-container #qv-compareatprice',
      '.product-popup-modal #qv-text-container #qv-variants .swatch-wrapper .option-label label',
      '.product-popup-modal #qv-text-container #qv-productname',
      '.btn, .button, .customer button, .shopify-challenge__button, a.btn',
      '.product-popup-modal #qv-text-container #qv-price',
      '.caption-large',
      '.shippingdetails',
      '.cart-footer span',
      '.cart-footer2 span'
      // Add more classes as needed
    ];

    // Generate and apply dynamic CSS for the specified classes with !important
    const dynamicCSS = classesToAdjust.map(className => {
        const element = document.querySelector(className);
        if (element) {
            const currentFontSize = parseFloat(window.getComputedStyle(element).fontSize);
            const newSize = `calc(${currentFontSize}px + ${currentFontSize * (boundedFontSize / 100)}px) !important`;

            return `${className} { font-size: ${newSize}; }`;
        } else {
            return '';
        }
    }).join('\n');

    // Update the dynamic styles
    dynamicStyles.textContent = dynamicCSS;









      
  }  
}



// Call the function when the document is ready
document.addEventListener('DOMContentLoaded', increaseFontSize);


    document.addEventListener('DOMContentLoaded', function () {
      // Get all elements with the class "disclosure__item"
      var disclosureItems = document.querySelectorAll('.disclosure__item.language');

      // Add click event listener to each element
      disclosureItems.forEach(function (item) {
        item.addEventListener('click', function (event) {
          // Prevent the default link behavior
          event.preventDefault();

          // Get the "lang" attribute value of the clicked item
          var langValue = item.querySelector('.disclosure__link').getAttribute('lang');

          // Set the "lang" value to local storage
          localStorage.setItem('language', langValue);

          // You can do additional actions here if needed

          // Log the selected language to the console
          console.log('Selected language:', langValue);
        });
      });
    });



